import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
// import SuspenseWrapper from the correct path or create the file if missing
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const List = lazy(() => import('@/pages/notification/List'));
const Create = lazy(() => import('@/pages/notification/Create'));
const Edit = lazy(() => import('@/pages/notification/Edit'));
const Detail = lazy(() => import('@/pages/notification/Detail'));

export const notificationRoutes: RouteObject = {
  path: 'notifications',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:notifications:list">
          <SuspenseWrapper>
            <List />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:notifications:create">
          <SuspenseWrapper>
            <Create />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:notifications:edit">
          <SuspenseWrapper>
            <Edit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:id',
      element: (
        <ProtectedRoute pageKey="page:notifications:detail">
          <SuspenseWrapper>
            <Detail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};
